/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import FilterTab from 'components/common/FilterTab';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDataByDateRange from '../forms/GetDataByDateRange';
import fetchData from 'services/fetchData';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import LoadComponent from '../animate-component/LoadComponent';
import AdvanceTable from 'components/base/AdvanceTable';
import Backdrop from 'components/base/Backdrop';
import SearchBox from 'components/common/SearchBox';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExcelButton from 'components/functional-buttons/ExcelButton';
import { Dropdown } from 'react-bootstrap';
import Icon from 'components/icon';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import classNames from 'classnames';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
// import SelectFilteredData from './../../common/selectFilteredData';
import BranchDropdown from 'components/functional-buttons/BranchDropdown';
import illustration32 from 'assets/img/bg/39.png';
import PageLoader from '../animate-component/PageLoader';
import { useAuth } from 'hooks/auth/useAuth';

const generateFilter = (filterObj, filterFunc) => {
  return Object.keys(filterObj)?.map(fk => ({
    label: fk,
    value: fk,
    onClick: () => filterFunc(fk),
    count: filterObj[fk]
  }));
};

const RenderAction = ({
  action,
  defaultLabel,
  defaultIcon,
  className,
  eventKey,
  disabled
}) => {
  if (action) {
    return (
      <Dropdown.Item
        className={classNames(className, action.className)}
        style={{ opacity: action.disabled || disabled ? '0.3' : '1' }}
        eventKey={eventKey}
        onClick={action.action}
        disabled={action.disabled || disabled}
      >
        <Icon
          icon={action.icon ?? defaultIcon}
          className={classNames('me-1', action.iconClassName)}
          fontSize={action.fontSize ?? '14px'}
        />{' '}
        {action.label ?? defaultLabel}
      </Dropdown.Item>
    );
  }
  return null;
};

const generateColumn = ({ column, actions }, hideActionBackdrop) => {
  if (actions) {
    return [
      ...column,
      {
        id: 'action',
        header: 'Actions',
        cell: ({ row: { original } }) => {
          const getAction = actions(original);
          const { view, edit, actionStatus, actionDelete, otherActions } =
            getAction;
          return (
            <RevealDropdownTrigger>
              <RevealDropdown className="position-relative">
                <RenderAction
                  action={view}
                  defaultLabel={'View'}
                  defaultIcon={'tabler:eye'}
                  eventKey={'1'}
                />
                <RenderAction
                  action={edit}
                  defaultLabel={'Edit'}
                  defaultIcon={'tabler:edit'}
                  eventKey={'2'}
                />

                {otherActions?.map((otherAction, i) => (
                  <RenderAction
                    key={`${i}-other-action`}
                    action={otherAction}
                    defaultLabel={'action'}
                    defaultIcon={'mdi:block'}
                    eventKey={2 + i}
                  />
                ))}

                {actionStatus || actionDelete ? <Dropdown.Divider /> : null}
                <RenderAction
                  action={actionStatus}
                  disabled={original.status === 'Pending'}
                  defaultLabel={'status'}
                  defaultIcon={'mdi:block'}
                  eventKey={'3'}
                />
                <RenderAction
                  action={actionDelete}
                  disabled={original.status === 'Pending'}
                  defaultLabel={'Delete'}
                  defaultIcon={'tabler:trash'}
                  eventKey={'4'}
                  className="text-danger"
                />
                {!hideActionBackdrop && (
                  <Backdrop
                    show={
                      original.change_flag === '1' &&
                      original.status !== 'Pending'
                    }
                    className={
                      'position-absolute flex justify-content-center rounded align-items-center'
                    }
                  >
                    <p className="mb-0 text-warning-300 dark__text-warning-300 fs-9">
                      Waiting for approval
                    </p>
                  </Backdrop>
                )}
              </RevealDropdown>
            </RevealDropdownTrigger>
          );
        },
        meta: {
          headerProps: { style: { width: '7%' } },
          cellProps: { className: 'text-end' }
        }
      }
    ];
  } else {
    return column;
  }
};

const Page = ({
  title,
  pageHeader,
  tableColumn,
  urlEndPoint, // endpoint for fetching data
  exportName,
  searching = true,
  addNew = null,
  addBtnText = 'Add New',
  dataWithDateRange = false, // Date range filter
  showFilter = false,
  initialFilters = {},
  backdrop = { loading: false, message: 'Processing' },
  children,
  dummyData = [], //data for testing purpose
  createFilter = () => {},
  manageFilter = () => {},
  fetchCallback = () => {}, //return fetch data to parent component
  tableProps, //additional prop for table
  onRegisterRefresh, // pass refresh function to parent component
  onRegisterPushCustomData, // pass pushCustomData function to parent component
  otherButtons,
  dataFormatter, // function to formate fetch data before set to state
  highlightedRow = false,
  showIllustration = false,
  staticUrl = null, //passing static url
  addBtnIcon,
  containerClassName = 'mx-n4 mt-n5  mx-lg-n6',
  showTools = true,
  pageHeaderProps, //additional prop for table
  excelButtonProps = {},
  selectionButton, // a button when row select so this button appear in header
  createPermission = null,
  hideActionBackdrop = false
  // selectFilteredData
}) => {
  const [fetchedData, setFetchedData] = useState(dummyData);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [filterTab, setFilterTab] = useState(
    generateFilter(initialFilters, () => {})
  );
  const [filter, setFilter] = useState('All');
  const [searchParams, setSearchParams] = useSearchParams();
  const { abilities } = useAuth();

  const handleSetFetchData = (data, allowModifyData = true) => {
    if (dataFormatter) {
      const formattedData = allowModifyData ? dataFormatter(data) : data;
      setFetchedData(formattedData);
      fetchCallback(formattedData);
    } else {
      setFetchedData(data);
      fetchCallback(data);
    }
  };

  const handleFilter = filter => {
    setFilter(filter);
  };

  const fetchRequest = async () => {
    setLoading(true);
    const response = await fetchData(staticUrl || urlEndPoint, {
      isStatic: staticUrl
    });
    if (response.status) {
      handleSetFetchData(response.data);
    } else {
      setLoading(false);
    }
    setIsApiCalled(true);
  };

  useEffect(() => {
    if (!dataWithDateRange) {
      fetchRequest();
    }
  }, []);

  useEffect(() => {
    if (fetchedData?.length > 0 && showFilter) {
      const initFilter = { ...initialFilters };
      initFilter['All'] = fetchedData.length;
      createFilter(fetchedData, initFilter, modifiedFilter =>
        setFilterTab(generateFilter(modifiedFilter, handleFilter))
      );
    }
  }, [fetchedData, showFilter]);

  useEffect(() => {
    if (fetchedData?.length > 0) {
      if (showFilter) {
        if (filter === 'All') {
          setLoading(true);
          setFilteredData(fetchedData);
          setLoading(false);
        } else {
          setLoading(true);
          manageFilter(fetchedData, filter, filteredData =>
            setFilteredData(filteredData)
          );
          setLoading(false);
        }
      } else {
        setLoading(true);
        setFilteredData(fetchedData);
        setLoading(false);
      }
    } else if (isApiCalled) {
      setLoading(false);
      setFilteredData(fetchedData);
    } else if (fetchedData?.length === 0) {
      setFilteredData(fetchedData);
    }
  }, [fetchedData, filter, showFilter]);

  const table = useAdvanceTable({
    data: filteredData,
    columns: generateColumn(tableColumn, hideActionBackdrop),
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: true,
    ...tableProps
  });

  useEffect(() => {
    const searchQuery = searchParams.get('search');
    table.setGlobalFilter(searchQuery || undefined);
  }, [searchParams]);

  const handleSearchInputChange = e => {
    table.setGlobalFilter(e.target.value || undefined);
    if (searchParams.get('search') && e.target.value?.length <= 0) {
      searchParams.delete('search');
      setSearchParams(searchParams, { replace: true });
    }
  };

  const pushCustomData = (data, allowModifyData = true) => {
    handleSetFetchData(data, allowModifyData);
    setFilteredData(data);
  };

  const refreshData = async () => {
    setLoading(true);
    table.resetRowSelection();
    table.setGlobalFilter(undefined);
    const response = await fetchData(staticUrl || urlEndPoint, {
      isStatic: staticUrl,
      cache: 'reload'
    });
    if (response.status) {
      handleSetFetchData(response.data);
    } else {
      handleSetFetchData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (onRegisterRefresh && !dataWithDateRange) {
      onRegisterRefresh(refreshData);
    }
  }, [onRegisterRefresh, refreshData, dataWithDateRange]);

  useEffect(() => {
    if (onRegisterPushCustomData) {
      onRegisterPushCustomData(pushCustomData);
    }
  }, [onRegisterPushCustomData, pushCustomData]);

  const checkSelectedRow = () => {
    try {
      if (table?.getSelectedRowModel().rows) {
        return table?.getSelectedRowModel().rows.length;
      }
    } catch (e) {
      console.log('this is', e);
      return false;
    }
    return false;
  };

  return (
    <div className={classNames(containerClassName)}>
      {/* {title && <h2 className="mb-4 font-outfit fw-medium">{title}</h2>} */}
      <AdvanceTableProvider {...table}>
        <div
          className={` pb-2 pt-2 mt-7 position-relative px-4 px-lg-6 ${checkSelectedRow() && selectionButton ? 'bg-white' : ''}`}
          {...pageHeaderProps}
        >
          {showIllustration && (
            <div
              style={{
                position: 'absolute',
                objectFit: 'contain',
                width: '100%',
                backgroundImage: `url(${illustration32})`,
                backgroundRepeat: 'repeat',
                height: '100%',
                zIndex: '-1',
                opacity: '0.3',
                top: '0px',
                left: '0px'
              }}
            />
          )}

          {title && (
            <div className="gap-2 d-flex  justify-content-between flex-column flex-sm-row ">
              <div>
                <h2 className="mb-5 font-outfit fw-medium">{title}</h2>
              </div>
              <div className="mb-5">
                <BranchDropdown />
              </div>
            </div>
          )}

          {showFilter && (
            <div>
              <FilterTab
                tabItems={filterTab}
                className="mb-2 font-outfit fw-medium"
              />
            </div>
          )}

          {pageHeader}
          {showTools && (
            <div className="position-relative">
              {checkSelectedRow() > 0 && selectionButton && (
                <div className="bg-white w-100 h-100 position-absolute top-0 left-0 z-index-2">
                  <div className="h-100">
                    {selectionButton(
                      table?.getSelectedRowModel()?.rows,
                      table?.getSelectedRowModel()?.rows?.length
                    )}
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between flex-md-nowrap flex-wrap-reverse gap-3">
                {searching && (
                  <SearchBox
                    className="w-100 w-sm-auto"
                    placeholder="Search..."
                    onChange={handleSearchInputChange}
                  />
                )}
                {/* {selectFilteredData && <SelectFilteredData />} */}
                <div className="d-flex align-items-center justify-content-end ms-auto gap-1 flex-wrap">
                  {/* <Can I={'create'} this={moduleName}> */}
                  {addNew && (
                    <div className="ms-xxl-auto">
                      <Button
                        className="font-outfit"
                        variant="primary"
                        disabled={
                          createPermission
                            ? !abilities.can(
                                createPermission.action || 'maker',
                                createPermission.moduleName
                              )
                            : false
                        }
                        onClick={addNew}
                      >
                        <FontAwesomeIcon
                          icon={addBtnIcon ? addBtnIcon : faPlus}
                          className="me-2"
                        />
                        {addBtnText}
                      </Button>
                    </div>
                  )}
                  {/* </Can> */}
                  {otherButtons}
                  {dataWithDateRange ? (
                    <GetDataByDateRange
                      url={urlEndPoint}
                      staticUrl={staticUrl}
                      exportName={exportName}
                      loading={loading}
                      setLoading={setLoading}
                      setFetchedData={handleSetFetchData}
                      setGlobalFilter={val => table.setGlobalFilter(val)}
                      onRegisterRefresh={onRegisterRefresh}
                    />
                  ) : (
                    <div className="d-flex justify-content-end gap-1 h-100">
                      <ExcelButton {...excelButtonProps} prefix={exportName} />
                      <Button
                        className="p-0 px-2 position-relative"
                        variant="phoenix-primary"
                        title="Refresh table"
                        onClick={refreshData}
                      >
                        <Icon icon={'heroicons-outline:refresh'} />
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="px-4 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
          <LoadComponent height={430} loading={loading}>
            <div>
              <AdvanceTable
                highlightedRow={highlightedRow}
                loading={loading}
                tableProps={{
                  className: 'phoenix-table fs-8 advance-bold-table'
                }}
              />
              <AdvanceTableFooter pagination />
            </div>
          </LoadComponent>
        </div>
      </AdvanceTableProvider>
      {children}

      <PageLoader
        loading={backdrop.loading}
        loadingMessage={backdrop.message}
        fixed={true}
      />
    </div>
  );
};

export default Page;
